import { useEffect } from 'react';

const COOKIE_NAME = 'vwo_consent';

const getRootDomain = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');
  if (parts.length > 2) {
    return `.${parts.slice(-2).join('.')}`;
  }
  return `.${hostname}`;
};

export const useSetVwoCookie = (consent: boolean) => {
  useEffect(() => {
    let cookieString = `${COOKIE_NAME}=${encodeURIComponent(consent)}`;
    cookieString += `; expires=${new Date(Date.now() + 31536000000).toUTCString()}`;
    cookieString += `; domain=${getRootDomain()}`;
    cookieString += '; path=/';
    cookieString += '; secure';
    cookieString += '; samesite=none';

    document.cookie = cookieString;
  }, [consent]);
};
